<template>
	<div style="margin-top:20px;">
		<div class="info-wrap">
			<table cellspacing="1" width="100%" class="order-info">
				<tr>
					<td>待支付定单编码：{{depositBillMainVO.billCode}}</td>
				</tr>
				<tr>
					<td>苗场：{{depositBillMainVO.seedFarmName}}</td>
				</tr>
				<tr>
					<td>交货日期：{{depositBillMainVO.sendProductDate}}</td>
				</tr>
                <tr>
                	<td>周次：{{depositBillMainVO.weekSeq}} 周 </td>
                </tr>
               <!-- <tr>
                	<td>待付金额：{{depositBillMainVO.remainingSum}}元 </td>
                </tr> -->
			</table>
		</div>

		<div class="dataTable">
			<b-table id="orderDetail-table" :fields="orderDetail.fields" :items="orderDetail.items" small bordered hover
				:busy="orderDetail.isTableBusy" caption-top>
				<template v-slot:cell(index)="row">
					<template v-if="row.item.productCode==''||row.item.productCode=='定金收取(%)'">
						<span></span>
					</template>
					<template v-else>
						  {{ row.index + 1 }}
					</template>
				</template>
				<template v-slot:cell(productName)="row">
					<template v-if="row.item.productCode=='定金收取(%)'">
						{{ allTotalMoney?Math.round(row.item.totalMoney*100/allTotalMoney):0}}
					</template>
					<template v-else>
						  {{ row.item.productName}}
					</template>
				</template>
				<template v-slot:cell(totalMoney)="row">
					<template v-if="row.item.productCode=='定金收取(%)'">
						<input type="number" v-model="row.item.totalMoney" style="font-size: 24rpx;border: 1px solid #666;height: 52rpx;width:100px;text-align: center;" min="0" />
					</template>
					<template v-else-if="row.item.preSalePlanPrice=='总额'||row.item.productName=='折扣'">
						  	<span>{{ parseFloat(row.item.totalMoney.toFixed(2)) }}</span>
					</template>
					<template v-else>
						  {{ row.item.totalMoney}}
					</template>
				</template>
				<template v-slot:cell(orderQuantity)="row">
					<template v-if="row.item.depositBillDetailUuid||row.item.unitName=='数量合计'">
							  {{parseFloat(row.item.orderQuantity) }}
					</template>
					<template v-else>
						  {{ row.item.orderQuantity}}
					</template>
				</template>
				<template slot="table-caption">
					<span style="font-weight: bold;">待支付定单详细信息:{{depositBillMainVO.billCode}}</span>
					<!-- <span style="color:red;">请于{{depositBillMainVO.sendProductDateBefore}}前打款支付余额。（交货日三天前）</span> -->
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
			</b-table>
			<!-- <p>客户备注:<strong>{{depositBillMainVO.customerMsg}}</strong></p> -->
			<textarea v-model="depositBillMainVO.customerMsg" autocomplete="off" style="height: 40px ;margin-bottom: 20px;" class="form-control" aria-label="With textarea" placeholder="请输入订单备注(选填)"></textarea>
			<div class="onPay">
				<b-button size="sm"  style="margin-right:100px;" type="info" variant="info" v-on:click="showContract(depositBillMainVO)">
                      查看种苗定购协议
                  </b-button>
				<b-button style="margin-right:20px;" size="20" @click="onPayDeposit">支付定金</b-button>
				<b-button variant="success" size="20"  @click="onPayBalance">支付总额</b-button>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/api/api';
	import {
		formatDateTimeString,
		numberToFixed
	} from '@/libs/utils';
	import search from '@/libs/search';
	import "@/style/global.css";
	export default {
		name: 'BookingOrderDetail',
		components: {
		},
		data() {
			return {
				orderDetail: {
					fields: [
						{
						    key: "index",
						    label: "序号"
						},
						{
                            key: "productCode",
                            label: "品种编号"
                        },
                        {
                            label: "品种名称",
                            key: "productName"
                        },
                        {
                            label: "单位",
                            key: "unitName"
                        },
                        {
                            label: '数量',
                            key: 'orderQuantity'
                        },
                        {
                            label: '单价',
                            key: 'preSalePlanPrice'
                        },
                        {
                            label: '金额',
                            key: 'totalMoney'
                        }
					],
					items: [],
					isTableBusy: false
				},
                depositBillMainVO:{},
				isCheckContract:false,
				allTotalMoney:0
			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: "MemberLogin"
				});
				return;
			}
			this.getOrderDetailInfo();
		},
		methods: {
			formatDateTimeString,
			numberToFixed,
			getOrderDetailInfo() {
				this.orderDetail.isTableBusy = true;
				api.webPreSaleGetOrderDetail({
					depositBillRecordUuid: this.$route.query.depositBillRecordUuid
				}).then(res => {
					this.orderDetail.isTableBusy = false;
					if (res.code === 0) {
					    if (res.data.depositBillMainVOList != null) {
                            this.depositBillMainVO = res.data.depositBillMainVOList[0];
					        this.orderDetail.items = res.data.depositBillMainVOList[0].orderItmeList;
							let allTotalMoneyRow= res.data.depositBillMainVOList[0].orderItmeList.find(x=>x.preSalePlanPrice=='金额合计')
                            this.allTotalMoney=allTotalMoneyRow.totalMoney;
							console.log(this.allTotalMoney);
							
					    }
					}
				});
			},
			showContract(depositBillVo) {
              this.isCheckContract = true;
              let cartItems = [];
              depositBillVo.orderItmeList.filter(x=>x.depositBillDetailUuid).forEach(e => {
                  if (e.productCode) {
                      cartItems.push({
                          productUuid: '',
                          brandName: '',
                          productName: e.productName,
                          unitName: e.unitName,
                          productCode: e.productCode,
                          displayPrice: e.preSalePlanPrice,
                          orderQuantity: e.orderQuantity,
                          sendDate: depositBillVo.sendProductDate
                      });
                  }
              });
              api.webGetContract({
                  items: cartItems,
                  depositBillRecordUuid: depositBillVo.depositBillRecordUuid
              }).then(res => {
                  if (res.code === 0) {
                      this.contractPath = res.data.url;
                      let url = api.downLoadServer + res.data.url.replace(/\\/g, '\/');
                      window.open(url, '_blank');
                  } else {
                      this.$bvModal.msgBoxOk("生成合同失败，请联系客户经理！", {
                          title: '提示',
                          buttonSize: 'sm'
                      });
                  }
              });
          },
			// 支付定金
			onPayDeposit(){

				if (!this.isCheckContract) {
                  this.$bvModal.msgBoxOk("请先查看种苗定购协议！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }
				//判断当前小计里是否有0的订单，如果有，则提示要去除
				let zeroSign = false;
				if (this.depositBillMainVO.totalMoneyActual == 0) {
					zeroSign = true;
					return;
				}
				if (zeroSign) {
				    this.$bvModal.msgBoxOk("产品金额不能为0，请取消相应的产品！", {
				        title: '提示',
				        buttonSize: 'sm'
				    });
				    return;
				}
				let depositBillRecordUuidArray = []
				let depositValueArray = []
				let customerMsgArray = []
				depositBillRecordUuidArray.push(this.$route.query.depositBillRecordUuid)
				this.depositBillMainVO.orderItmeList.forEach(item =>{
						if(item.productCode=='定金收取(%)'){
							depositValueArray.push(item.totalMoney);
						}
					});
				customerMsgArray.push(this.depositBillMainVO.customerMsg)
				api.webPreSaleDepositPayWithFund({
				    depositBillRecordUuidArray,
					depositValueArray, 
					customerMsgArray ,
				    orderType: 'DEPOSIT'
				}).then(res => {
				    if (res.code === 0) {
				        this.$bvModal.msgBoxOk("支付定金成功，现跳转至定金单。", {
				            title: '提示',
				            buttonSize: 'sm'
				        });
				        let that = this;
				        setTimeout(function() {
				            that.$router.push({
				                path: "/member/deposit-list"
				            });
				        }, 1000);
				    }
				});
			},
			// 全额支付
			onPayBalance(){

				if (!this.isCheckContract) {
                  this.$bvModal.msgBoxOk("请先查看种苗定购协议！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }
				//判断当前小计里是否有0的订单，如果有，则提示要去除
				let zeroSign = false;
				if (this.depositBillMainVO.totalMoneyActual == 0) {
					zeroSign = true;
					return;
				}
				if (zeroSign) {
				    this.$bvModal.msgBoxOk("产品金额不能为0，请取消相应的产品！", {
				        title: '提示',
				        buttonSize: 'sm'
				    });
				    return;
				}
				let depositBillRecordUuidArray = []
				let customerMsgArray = []
				depositBillRecordUuidArray.push(this.$route.query.depositBillRecordUuid)
				customerMsgArray.push(this.depositBillMainVO.customerMsg)
				api.webPreSaleDepositPayWithFund({
				    depositBillRecordUuidArray,
					customerMsgArray,
				    orderType: 'TOTALMONEY'
				}).then(res => {
				    if (res.code === 0) {
				        this.$bvModal.msgBoxOk("全额支付成功，现跳转至发货单。", {
				            title: '提示',
				            buttonSize: 'sm'
				        });
				        let that = this;
				        setTimeout(function() {
				            that.$router.push({
				                path: "/delivery-list/delivery-list"
				            });
				        }, 1000);
				    }
				});
			}
		}
	};
</script>

<style>
	.date-before{
		margin-top: 20px;
		font-weight: bold;
		color: #ec4040;
	}
	.orderKey {
		text-align: right;
		font-size: 14px;
		font-weight: bold;
	}

	.orderValue {
		font-size: 14px;
	}


	/* 信息 */
	.info-wrap {
		width: 100%;
		border: 1px solid #efefef;
		margin: 20px auto;
		background-color: #fafafa;
		padding: 15px 0px;
	}

	.info-wrap .order-info td {
		padding: 5px 30px;
	}

	.info-wrap .order-info td:nth-child(even) {
		color: #a16e02;
	}



	/* 表格 */
	.dataTable {
		margin: 20px 0;
	
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table.b-table.b-table-caption-top>caption {
		color: #333;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
        font-size: 14px;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}

	/* 页码 */
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}
    .dataTable td{
        font-size: 14px;
    }
	.onPay{
		display: flex;
		justify-content: end;
	}
</style>



// WEBPACK FOOTER //
// src/view/no-deposit-list/no-deposit-detail.vue